<template>
  <v-card class="pa-4">
    <h3 class="text-center mt-3">
      {{ isEditing ? $t('Atualizar') : $t('Adicionar') }} solução
    </h3>

    <v-btn
      absolute
      top
      right
      class="delete-button"
      text
      icon
      @click="$emit('close')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <v-form ref="form">
      <v-row class="ma-0" dense>
        <v-col cols="12">
          <span class="text ml-1">{{ $t('Solução') }}</span>
          <v-text-field
            class="primary-input"
            :placeholder="$t('Pesquisar por solução')"
            v-model="solution.solution"
            :rules="[(v) => !!v || $t('Solução obrigatória')]"
            outlined
            hide-details="auto"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="12" v-if="institution.departmentTypes.includes(1)">
          <span class="text ml-1">{{ $t('Oficina') }}</span>
          <v-autocomplete
            :items="workshops"
            multiple
            item-text="name"
            item-value="id"
            v-model="selectedWorkshops"
            :loading="workshopsLoading"
            :rules="[(v) => v != null || $t('Oficina obrigatória')]"
            append-icon="mdi-chevron-down"
            class="primary-input"
            :placeholder="$t('Pesquisar por oficina')"
            outlined
            hide-details="auto"
          >
            <template v-slot:selection="{ attrs, item, select, selected }">
              <v-chip
                v-bind="attrs"
                :input-value="selected"
                close
                color="#BBCF20"
                text-color="#fff"
                small
                @click="select"
                @click:close="removeWorkshop(item)"
              >
                {{ item.name }}
              </v-chip>
            </template>
            <template v-slot:item="{ item }">
              <span class="text-caption">
                {{ item.name }}
              </span>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <div class="d-flex justify-end">
        <v-btn class="clear-button mr-1" depressed @click="$emit('close')">
          Cancelar
        </v-btn>
        <v-btn
          @click="submit"
          class="secondary-button mr-1"
          depressed
          :loading="loading"
        >
          {{ isEditing ? $t('Atualizar') : $t('Adicionar') }}
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from '../../../services/ApiService'
export default {
  name: 'ManageSolutionsPage',

  props: {
    solutionProp: Object,
  },

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))

    this.getWorkshops()

    if (this.solutionProp && this.solutionProp.id) {
      this.solution = { ...this.solutionProp }

      this.selectedWorkshops = this.solution.workshops.map((x) => x.workshopId)
      this.isEditing = true
    }

    this.solution.institutionId = this.solution.institutionId
      ? this.solution.institutionId
      : this.institution.id
  },

  data() {
    return {
      workshopsLoading: false,
      institution: {},
      apiService: new ApiService(),
      isEditing: false,
      loading: false,
      solution: {},
      selectedWorkshops: [],
      workshops: [
        // { text: 'Engenharia Clínica', value: 0, inst: 0 },
        // { text: 'Carpintaria', value: 1, inst: 1 },
        // { text: 'Elétrica', value: 2, inst: 1 },
        // { text: 'Hidráulica', value: 3, inst: 1 },
        // { text: 'Climatização', value: 4, inst: 1 },
        // { text: 'Gasoterapia', value: 5, inst: 1 },
        // { text: 'Zeladoria', value: 6, inst: 1 },
        // { text: 'Vidraçaria', value: 7, inst: 1 },
        // { text: 'Mecânica', value: 8, inst: 1 },
        // { text: 'Serralheria', value: 9, inst: 1 },
        // { text: 'Predial Civil', value: 10, inst: 1 },
        // { text: 'Pintura Predial', value: 11, inst: 1 },
        // { text: 'Pintura Industrial', value: 12, inst: 1 },
      ],
    }
  },

  methods: {
    async getWorkshops() {
      try {
        this.workshopsLoading = true
        const response = await this.apiService.get(
          `workshop/${this.institution.id}`
        )
        this.workshops = response.content
        this.workshopsLoading = false
      } catch (error) {
        console.error('Erro ao buscar workshops:', error)
        this.workshopsLoading = false
      } finally {
        this.workshopsLoading = false
      }
    },

    removeWorkshop(item) {
      this.selectedWorkshops.splice(this.selectedWorkshops.indexOf(item), 1)
      this.selectedWorkshops = [...this.selectedWorkshops]
    },

    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true

        this.solution.workshops = this.selectedWorkshops.map((x) => {
          return {
            workshopId: x,
          }
        })

        if (this.isEditing) {
          await this.apiService
            .put(`defectSolution/edit`, this.solution)
            .then(() => {
              this.$toast.success('Solução Defeito atualizada! Tudo em ordem ✨')
              this.$emit('confirm')
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          await this.apiService
            .post(`defectSolution/add`, this.solution)
            .then(() => {
              this.$toast.success('Solução Defeito adicionada! 👏')
              this.$emit('confirm')
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        }
      }
    },
  },
}
</script>

<style scoped></style>
